import '../../../base/css/base.pcss';
import '../../../base/js/base';

import '../../parts/header/index';
import '../../parts/footer/index';

/* shortcodes */
import '../../shortcodes/submit-button/index';
import '../../shortcodes/contact-block/index';
import '../../shortcodes/clients-carousel/index';
import '../../shortcodes/arrow-button/index';

/* modules */
import '../../modules/side-testimonial-block/index';

/* page templates */
import '../../templates/page/index';

import './clients.pcss';
import './clients';